import React, { useState } from 'react';
import styles from './styles/input.module.scss';

function Input({ rightIcon, leftIcon, label, onChange, value, error, ...props }) {
    const [isFocused, setIsFocused] = useState(false);

    const handleFocus = () => {
        setIsFocused(true);
    };

    const handleBlur = () => {
        setIsFocused(false);
    };

    const handleChange = (e) => {
        if (onChange) {
            onChange(e);
        }
    };

    const isLabelFloating = isFocused || (value && String(value).length > 0);

    return (
        <div className={`${styles.inputContainer} ${error ? styles.error : ''}`}>
            <div className={`${styles.inputWrapper} ${leftIcon ? styles.hasLeftIcon : ''} ${rightIcon ? styles.hasRightIcon : ''}`}>
                {leftIcon && <div className={styles.iconLeft}>{leftIcon}</div>}
                <input {...props} value={value} onChange={handleChange} onFocus={handleFocus} onBlur={handleBlur} className={styles.input} placeholder="" />
                <label className={`${styles.label} ${isLabelFloating ? styles.labelFloating : ''}`}>{label}</label>
                {rightIcon && <div className={styles.iconRight}>{rightIcon}</div>}
            </div>
        </div>
    );
}

export default Input;
